import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import * as echarts from 'echarts/lib/echarts';
import { pieChartColor } from "../../../../utils/commonConsts";
import merge from 'deepmerge';
var BossBarChart = /*#__PURE__*/function (_React$Component) {
  _inherits(BossBarChart, _React$Component);
  function BossBarChart(props) {
    var _this;
    _classCallCheck(this, BossBarChart);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(BossBarChart).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "initChart", function (el) {
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            interval: 0,
            fontSize: 14
          }
        },
        yAxis: {
          type: 'category',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0,
            fontSize: 14
          }
        },
        color: pieChartColor,
        series: []
      };
      option = merge(option, _this.props.option);
      el.setOption(option, {
        notMerge: _this.props.ifNotMerge
      });
    });
    _this.state = {};
    return _this;
  }
  _createClass(BossBarChart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.chart = echarts.init(document.getElementById(this.props.id));
      if (this.props.onClick) {
        this.chart.on('click', this.props.onClick);
      }
      this.initChart(this.chart);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return JSON.stringify(nextProps.option) !== JSON.stringify(this.props.option);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.initChart(this.chart);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        id: this.props.id,
        style: {
          width: this.props.containerWidth,
          height: this.props.containerHeight
        }
      });
    }
  }]);
  return BossBarChart;
}(React.Component);
BossBarChart.defaultProps = {
  containerWidth: document.body.clientWidth - 300,
  containerHeight: 720,
  ifNotMerge: true
};
export default BossBarChart;